var PDP_object_benefits_popup_slider = document.querySelector('.PDP_object_benefits_popup_slider');

if (PDP_object_benefits_popup_slider) {
    const popupSwiper = new Swiper('.PDP_object_benefits_popup_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        centeredSlides: true,
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                spaceBetween: 0
            },
            750: {
                spaceBetween: 0
            },
            990: {
                spaceBetween: 0
            },
            1200: {
            },
            1440: {
            }
        }
    })

    /* Popup Open & close */
    document.addEventListener('click', function (event) {
        const target = event.target.closest('.PDP_object_benefits_popup_static_block_new');
        if (!target) return;

        const realIndex = target.getAttribute('data-swiper-slide-index');
        const slideIndex = parseInt(realIndex, 10) || 0;
        console.log(realIndex)

        // Add open class
        document.querySelector('.overlay_background').classList.add('open');
        document.querySelector('body').classList.add('benefits_popup_open');

        // Fade in popup
        const popup = document.querySelector('.PDP_object_benefits_popup_detail_new');
        popup.style.display = 'block';
        popup.style.opacity = 0;

        requestAnimationFrame(() => {
            popup.style.transition = 'opacity 0.3s ease';
            popup.style.opacity = 1;
        });

        // Swiper slide
        popupSwiper.slideTo(slideIndex, 0);
    });

    document.querySelectorAll('.PDP_object_benefits_popup_detail_popup_block_icons_new, .overlay_background').forEach(function (el) {
        el.addEventListener('click', function () {

            document.querySelector('.overlay_background').classList.remove('open');
            document.querySelector('body').classList.remove('benefits_popup_open');

            const popup = document.querySelector('.PDP_object_benefits_popup_detail_new');

            // Fade-out animation
            popup.style.transition = 'opacity 0.3s ease';
            popup.style.opacity = '0';

            // Delay to match fade-out duration
            setTimeout(() => {
                popup.style.display = 'none';
            }, 300); // 300ms delay
        });
    });
}